import { removeItem } from '../storage';
import { cleanupFeatureFlagsOnLogout } from '../featureFlags/featureFlagIntegrationNew';

export const handleUnauthorized = () => {
    const localStorageIsUnauthorized = localStorage.getItem('isUnauthorized');
    const isUnathorizedValitation = localStorageIsUnauthorized && JSON.parse(localStorageIsUnauthorized);
    if (!isUnathorizedValitation) { return; }
    
    // Clean up feature flags on unauthorized logout
    cleanupFeatureFlagsOnLogout();
    
    removeItem('user');
    removeItem('lqaUser');
    removeItem('originalUser');
    window.location.href = '/login';
    };
